import React from "react";

import HomeHero from "./HomeHero.jsx";

import HomeContent from "./HomeContent";
import Seo, {
  breadcrumbSchema,
  organizationSchema,
  privateLabelServiceSchema,
  webPageSchema,
  websiteSchema,
} from "../Seo/Seo";

function Home() {
  return (
    <main className="home-page home-discovery mobile-type">
    <Seo
      title="Private Label Laundry Detergent Sheets Manufacturer | Klean Leaf"
      description="Klean Leaf is a private label laundry detergent sheets manufacturer offering custom formulas, fragrances and packaging, plus tablets, pods and more."
      path="/"
      schema={[
        organizationSchema,
        websiteSchema,
        privateLabelServiceSchema,
        webPageSchema({
          name: "Private Label Laundry Detergent Sheets Manufacturer | Klean Leaf",
          description: "Klean Leaf is a private label laundry detergent sheets manufacturer offering custom formulas, fragrances and packaging, plus tablets, pods and more.",
          path: "/",
        }),
        breadcrumbSchema([{ name: "Home", path: "/" }]),
      ]}
    />
    <HomeHero />
    <HomeContent />
    </main>
  );
}

export default Home;
